var map = {
	"./_allies.scss": "./src/sass/pages/_allies.scss",
	"./_blog.scss": "./src/sass/pages/_blog.scss",
	"./_contact.scss": "./src/sass/pages/_contact.scss",
	"./_detailBlog.scss": "./src/sass/pages/_detailBlog.scss",
	"./_example.scss": "./src/sass/pages/_example.scss",
	"./_gallery.scss": "./src/sass/pages/_gallery.scss",
	"./_home.scss": "./src/sass/pages/_home.scss",
	"./_interna_galeria.scss": "./src/sass/pages/_interna_galeria.scss",
	"./_landing.scss": "./src/sass/pages/_landing.scss",
	"./_ranking.scss": "./src/sass/pages/_ranking.scss",
	"./_session.scss": "./src/sass/pages/_session.scss",
	"./_solution.scss": "./src/sass/pages/_solution.scss",
	"./legals.scss": "./src/sass/pages/legals.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/sass/pages sync recursive ^\\.\\/.*\\.scss$";